export enum EnumCatalogoGralBanderas {
  Ninguno,
  EsCH,
  EsPorcentaje,
  ConceptosDelPpto
}
